import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

interface IFireFighting {
  extinguishingMedia?: string;
  specialFireHazards?: string;
  adviceForFirefighters?: string;
  expanded: boolean;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      display: 'flex',
      flexDirection: 'column',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const FireFighting: React.FC<IFireFighting> = ({
  extinguishingMedia,
  specialFireHazards,
  adviceForFirefighters,
  expanded,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel8`)}
      key={'panel8'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel8bh-content`}
        id={`panel8bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.fire_fighting')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.list}>
        {extinguishingMedia && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.extinguishing_media')}</b> ${extinguishingMedia}` }} />
        )}
        {specialFireHazards && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.special_fire_hazards')}</b> ${specialFireHazards}` }} />
        )}
        {adviceForFirefighters && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.advice_for_firefighters')}</b> ${adviceForFirefighters}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default FireFighting;
